// The audits' fixtures stay out of a normal session. Audit pages set this flag
// once via localStorage before the app boots (createNewPage in
// scripts/lib/web-audit-helpers.mjs); read it once, not subscribed, since it
// never changes during a session.
export function readAuditFixturesFlag(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage?.getItem('redi:auditFixtures') === '1';
  } catch {
    return false;
  }
}
